export default __webpack_public_path__ + "static/media/konkurs_img.450df818.png";